import React, { useState } from "react";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "../../../../style/buttons.scss";
import { BasketItem } from "../../../models/BasketItem";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import { ADD_TO_BASKET_URL } from "../../../api/apiRoutes";
import { ApiResult } from "../../../models/ApiResult";
import tryCatchRequest from "../../../api/tryCatchRequest";
import { useDispatch, useSelector } from "react-redux";
import { BsBasket3 } from "react-icons/bs";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import useParentMessage from "../../../../utils/hooks/useParentMessage";
import { setAddToBasketMessage } from "../../../store/alerts/alertsActions";
import useFacility from "../../../../utils/hooks/useFacility";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import { useNavigate } from "react-router";
import { FINALIZE_PAGE } from "../../../routes";
import { State } from "../../../store";
import { QntStateItem } from "../../../models/QntStateItem";
import EAButton from "../../shared/Buttons/EAButton";
import { gaEvent } from "../../../../utils/Analitics/ga";
import { canSendToFacebookPixel, canSendToGTM } from "../../../../utils/Analitics/analiticsConfigByFacility";
import { GA_ADD_TO_CART } from "../../../../utils/Analitics/gaEventsConsts";
import { sendAddToCartEvent } from "../../../../utils/Analitics/GtmEvents";

interface IProps {
  preBasket: BasketItem[];
  clearBasket: () => void;
  ticketLimit?: number;
  qntState?: QntStateItem[];
}

const PreBasketSummary: React.FC<IProps> = ({ preBasket, clearBasket, ticketLimit, qntState }: IProps) => {
  const { post } = useApiRequest();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useDesktopSize();
  const { scrollToTop } = useParentMessage();
  const facilityIds = useFacility();
  const [alert, setAlert] = useState<string>("");
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const addBasketRequest = async () => {
    const response = await Promise.all(preBasket.map(async (params) => await post(ADD_TO_BASKET_URL, params)));
    return response.reduce(
      (acc: ApiResult, item: ApiResult) => ({
        isError: item.isError ? item.isError : acc.isError,
        errorTable:
          item.errorTable.length > 0 && item.isError === true ? setAlert(item.errorTable[0]) : finalizeFunction(),
      }),
      {} as ApiResult
    );
  };

  const saveBasket = async () => {
    await tryCatchRequest(
      async () => addBasketRequest(),
      () => clearBasket(),
      dispatch
    );
    scrollToTop();

    //Metoda przejścia do koszyka po poprawnym zakupie
  };

  const finalizeFunction = () => {
    if (saleConfiguration.popupAfterAddTicket === true) {
      dispatch(setAddToBasketMessage(t("dodano_do_koszyka")));
      //  scrollToId('AddToBasketMessage')
    }

    if (saleConfiguration.popupAfterAddTicket === false) {
      setTimeout(() => {
        navigate(FINALIZE_PAGE);
      }, 100);
    }
  };

  const pixelAddBasket = () => {
    // Calculate basket total
    const basketTotal = preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);

    // Google Analytics - Fix for proper GA4 ecommerce tracking
    gaEvent(
      facilityIds,
      "ecommerce",
      GA_ADD_TO_CART,
      {
        event_category: "ecommerce",
        currency: "PLN",
        value: basketTotal,
        items: preBasket.map((item) => ({
          item_id: item.assortIds.replace(/^0,\+/, ""),
          item_name: item.assortName || "Produkt",
          price: item.price,
          quantity: item.qnt,
        })),
      },
      "add_to_cart"
    );

    // Facebook Pixel
    if (canSendToFacebookPixel(facilityIds)) {
      const pixelValue = preBasket.length > 0 ? preBasket[0].price * preBasket[0].qnt : 0;
      ReactPixel.fbq("track", "addEventTicketToBasket", {
        value: pixelValue,
        quantity: preBasket.length > 0 ? preBasket[0].qnt : 0,
        currency: "PLN",
      });
    }

    // Google Tag Manager
    if (canSendToGTM(facilityIds) && preBasket.length > 0) {
      // Przygotowanie danych dla GTM
      const gtmEvent = {
        currency: "PLN",
        value: basketTotal,
        items: preBasket.map((item) => ({
          item_id: item.assortIds.replace(/^0,\+/, ""),
          item_name: item.assortName || "Produkt",
          price: item.price,
          quantity: item.qnt,
        })),
      };

      // Wysłanie eventu do GTM
      sendAddToCartEvent(facilityIds, gtmEvent);
    }
  };
  const sumBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);

  return (
    <>
      {alert.length > 2 && alert !== t("dodano_bilet_do_koszyka") && <div className="alert alert-red">{alert}</div>}

      <div className="pre-basket-summary flex-end-center">
        <div className="flex-between-center">
          <span className="sum-basket">
            {t("suma")}:{" "}
            <b>
              {sumBasket()} {t("zl")}
            </b>
          </span>

          {preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0) > 0 ? (
            <EAButton
              title={isDesktop ? t("dodaj_do_koszyka") : t("dodaj")}
              endIcon={<BsBasket3 />}
              onClick={() => {
                saveBasket();
                pixelAddBasket();
              }}
            />
          ) : (
            <EAButton
              title={isDesktop ? t("dodaj_do_koszyka") : t("dodaj")}
              endIcon={<BsBasket3 />}
              onClick={() => {
                saveBasket();
                pixelAddBasket();
              }}
              disabled
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PreBasketSummary;
